// One registered landing-page callback; never click DOM or execute arbitrary routes.
let handler = null;
export function registerAccountAction(callback) {
  handler = callback;
  return () => { if (handler === callback) handler = null; };
}
export async function requestAccountAction(action) {
  if (!['get_started','signin'].includes(action) || !handler) return false;
  const current = handler;
  let timer;
  try {
    const opened = await Promise.race([
      Promise.resolve().then(() => current(action)),
      new Promise(resolve => { timer = setTimeout(() => resolve(false), 5000); })
    ]);
    return handler === current && opened === true;
  } catch { return false; }
  finally { clearTimeout(timer); }
}
